import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

import { environment } from '@env/environment';
import { CredentialsService } from '@app/auth';

/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  private readonly AUTHORIZATION_HEADER_KEY: string = 'Authorization' as const;

  constructor(private credentialsService: CredentialsService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!/^(http|https):/i.test(request.url)) {
      request = request.clone({ url: environment.serverUrl + request.url });
    }

    if (this.credentialsService.isAuthenticated()) {
      request = request.clone({
        setHeaders: {
          [this.AUTHORIZATION_HEADER_KEY]: `${this.credentialsService.token}`,
        },
      });
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>): void => {
        if (event instanceof HttpResponse) {
          const responseHeaders: HttpHeaders = event.headers;
          // if the current token expires, the back end will send a new refresh token that will be valid for a long time
          // We enter a timeframe called the "grace" period where both token (the expired one and the new one sent by the back end)
          // are valid. this grace period last for 1min.
          // this 1min period starts when an expired token is used for the first time
          // This is in case the FE sends simultaneous request with an expired token, they can work during the grace period.
          //
          // Note: when a token expires, the user has a limited time (I think 2weeks ?) where a refresh token will be sent by
          //       the back end, after these 2 weeks, we will receive a 401
          if (responseHeaders.has(this.AUTHORIZATION_HEADER_KEY)) {
            this.credentialsService.setToken(responseHeaders.get(this.AUTHORIZATION_HEADER_KEY));
          }
        }
      }),
    );
  }
}
